import { toCammelCase } from ".";

const prepareAmplitudeData = (
  currentStep: number,
  formStep: string,
  formType: string,
  source: string
) => {
  const formStepName = toCammelCase(formStep);
  const eventName = `view_form_step_${formStepName}`;

  let eventOptions: { form: string; source?: string } = {
    form: formType,
  };

  if (currentStep === 0) {
    eventOptions = {
      source: source,
      ...eventOptions,
    };
  }

  return {
    eventName,
    eventOptions,
  };
};

export default prepareAmplitudeData;
